import React from 'react';

const styles = {
  container: {
    textAlign: 'center',
    marginTop: 180,
  },
  header: {
    fontSize: 48,
    fontWeight: 100,
    margin: 20,
    lineHeight: '48px',
  },
};

export default function NotFound() {
  return (
    <div style={styles.container}>
      <div>
        <h1 style={styles.header}>
          404 Page Not Found
        </h1>
        <p>
          The requested URL was not found on this server.
        </p>
      </div>
    </div>
  );
}